import React from 'react'
import { Box } from '@mui/material'
import NavBar from '../../Components/NavBar/navbar'
import HeroSection from '../../Components/Hero/hero'
import AboutSection from '../../Components/About/about'
import FooterSection from '../../Components/Footer/footer'
import ProductsSection from '../../Components/Products/products'
import GetInTouchSection from '../../Components/GetInTouch/getintouch'
import EmptyContainerSection from '../../Components/EmptyContainer/emptycontainer'
import usePageTitle from '../../Components/Arcade/ui/usePageTitle'



export default function Home() {
  usePageTitle('Home')
  return (
    <Box component="main" sx={{ width:'100%' }}>
        <NavBar/>
        <HeroSection id='hero'/>
        <AboutSection id='about'/>
        <ProductsSection id='product'/>
        <EmptyContainerSection/>
        <GetInTouchSection/>
        <FooterSection/>
      </Box>
  )
}
